const PrivacyRequestType = {
  DO_NOT_SELL: 'DO_NOT_SELL',
  DATA_DELETION: 'DATA_DELETION',
  DATA_REPORT: 'DATA_REPORT',
  _Values: () =>
    Object.keys(PrivacyRequestType)
      .filter(key => typeof PrivacyRequestType[key] !== 'function')
      .map(key => PrivacyRequestType[key]),
};

const Status = {
  CREATED: 'CREATED',
  _Values: () =>
    Object.keys(Status)
      .filter(key => typeof Status[key] !== 'function')
      .map(key => Status[key]),
};

module.exports = { PrivacyRequestType, Status };
